import React from 'react';
import withTheme from '@material-ui/core/styles/withTheme';
import SvgIcon from '@material-ui/core/SvgIcon';

function Project(props) {
    const pathColour1 = props.theme.palette.primary.main,
        pathColour2 = props.theme.palette.secondary.dark;
    
    return (
        <SvgIcon viewBox="0 0 48 48" {...props}>
            <g id="ProjectIcon">
                <path 
                    fill={pathColour2}
                    d="M41.82,40.78a.85.85,0,0,1,.85.86h0A5.41,5.41,0,0,1,37.26,47H11.48a5.37,5.37,0,0,1-5.37-5.36v0a.82.82,0,0,1,.81-.81h.54a.81.81,0,0,1,.81.81h0a3.28,3.28,0,0,0,3.27,3.27H37.26a3.25,3.25,0,0,0,3.26-3.21h0a.86.86,0,0,1,.86-.86Zm-34.63-25h0a1.09,1.09,0,0,1-1.08-1.08V11.66a1.09,1.09,0,0,1,.34-.75L16,1.31A1.11,1.11,0,0,1,16.79,1H37.26a5.41,5.41,0,0,1,5.41,5.36v8.37a1.08,1.08,0,0,1-1.07,1.08h0a1.09,1.09,0,0,1-1.08-1.08V6.42a3.28,3.28,0,0,0-3.26-3.27H17.84V8a4.66,4.66,0,0,1-1.37,3.33,4.71,4.71,0,0,1-3.34,1.38H8.27v2A1.08,1.08,0,0,1,7.19,15.81Zm2.63-5.23h3.31A2.58,2.58,0,0,0,15,9.83,2.51,2.51,0,0,0,15.69,8V4.68Z" />

                <path 
                    fill={pathColour1}
                    d="M23,32.45H25V36H23Zm9.62,4.81h1.92V32.45H32.66Zm-19.24,0h1.92V32.45H13.42ZM42.28,19a1,1,0,0,0-1-1H24v1.92H40.36v1.92h1.92Zm2.89,7.69a1,1,0,0,0,1-1V21.86a1,1,0,0,0-1-1H5.72a1,1,0,0,0-.53.16L2.3,23a1,1,0,0,0-.27.26,1,1,0,0,0,.27,1.34l2.89,1.92a.9.9,0,0,0,.53.16ZM4.57,23.79l1.44-1H44.2v1.92H6Zm32.9,1.92h1.92V21.86H37.47ZM46.13,36.3V30.52A1.92,1.92,0,0,0,44.2,28.6H3.8a1.92,1.92,0,0,0-1.93,1.92V36.3A1.92,1.92,0,0,0,3.8,38.22H44.2A1.92,1.92,0,0,0,46.13,36.3ZM44.2,30.52V36.3H3.8V30.52Zm-26,6.74h1.92V33.41H18.23Zm9.62,0h1.92V33.41H27.85Zm9.62,0h1.92V33.41H37.47Zm-28.86,0h1.92V33.41H8.61Z" />
            </g>
        </SvgIcon>
    );
}

export default withTheme(Project);